var LiveRegionPoliteness;
(function (LiveRegionPoliteness) {
    LiveRegionPoliteness["ASSERTIVE"] = "assertive";
    LiveRegionPoliteness["OFF"] = "off";
    LiveRegionPoliteness["POLITE"] = "polite";
})(LiveRegionPoliteness || (LiveRegionPoliteness = {}));

export { LiveRegionPoliteness as L };
